/**
 * gif-timing.js — сколько кадров в GIF и сколько она длится.
 *
 * Браузер об этом не рассказывает: у картинки нет ни числа кадров, ни
 * длительности, поэтому «гифка вставилась замершим первым кадром» — потеря,
 * которую человек видит только в готовом файле. Единственный источник — сами
 * байты: каждый кадр предваряется Graphic Control Extension (0x21 0xF9 0x04),
 * а задержка в сотых долях секунды лежит в его байтах 4–5 (little-endian).
 *
 * ⚠️ Задержку 0 и 1 сс браузеры и вьюеры рисуют как 10 сс («как можно быстрее»
 * никто не исполняет буквально). Без этой поправки длительность выходит в разы
 * короче настоящей, и клип, собранный по ней, обрывается на середине анимации.
 *
 * ⚠️ Кадры размечены по ВСЕМУ файлу, а не в заголовке: читать префикс нельзя —
 * недосчитанные кадры дают короткую длительность, то есть тот же обрыв.
 *
 * Владелец ТАЙМИНГА — этот файл. У `photo-to-gif/decode.js` есть свой
 * `looksAnimated` (только булев ответ на «анимирована ли», без времён) — он
 * читает те же байты, и если правишь разбор здесь, посмотри и туда.
 */
(function (global) {
    'use strict';

    /**
     * scan(bytes) → { animated, frames, duration, fps } либо null, если кадр
     * один (такая GIF — обычная картинка, и обращаться с ней надо как с
     * картинкой).
     *
     * @param {ArrayBuffer|Uint8Array} buf  ВЕСЬ файл, не префикс
     */
    function scan(buf) {
        if (!buf) return null;
        var d = (buf instanceof Uint8Array) ? buf : new Uint8Array(buf);
        var frames = 0, cs = 0;
        for (var i = 0; i < d.length - 6; i++) {
            if (d[i] === 0x21 && d[i + 1] === 0xF9 && d[i + 2] === 0x04) {
                frames++;
                var delay = d[i + 4] | (d[i + 5] << 8);
                cs += (delay < 2 ? 10 : delay);
            }
        }
        if (frames < 2) return null;
        var dur = cs / 100;
        if (!(dur > 0.1)) dur = frames / 10;
        return {
            animated: true,
            frames: frames,
            duration: dur,
            fps: Math.max(1, Math.min(50, Math.round(frames / dur))),
        };
    }

    /** Это вообще GIF? По типу ИЛИ по имени: у файлов из мессенджеров type пуст. */
    function isGif(file) {
        if (!file) return false;
        return /gif/i.test(file.type || '') || /\.gif$/i.test(file.name || '');
    }

    /**
     * Прочитать файл и ответить про анимацию. Потолок чтения — 128 МБ: GIF
     * такого размера не бывает, а читать вслепую что угодно ради ответа
     * «анимирована ли» значит платить памятью за чужую ошибку.
     * Не бросает: не смогли прочитать → null, то есть «обращайся как с картинкой».
     */
    function scanFile(file) {
        if (!isGif(file) || !file.arrayBuffer) return Promise.resolve(null);
        if (file.size > 128 * 1048576) return Promise.resolve(null);
        return file.arrayBuffer().then(scan, function () { return null; });
    }

    global.GifTiming = { scan: scan, scanFile: scanFile, isGif: isGif };
})(typeof window !== 'undefined' ? window : globalThis);
